export default __webpack_public_path__ + "static/media/weight-banner.234cb549.jpg";